import type { ImgHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

type Variant = 'light' | 'dark';

interface ThuxLogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant?: Variant;
  className?: string;
}

const fullSrc: Record<Variant, string> = {
  light: '/logos/thux-light.svg',  // logo claro · pra fundo escuro
  dark: '/logos/thux-dark.svg',    // logo escuro · pra fundo claro
};

const markSrc: Record<Variant, string> = {
  light: '/logos/thux-mark-light.svg',
  dark: '/logos/thux-mark-dark.svg',
};

/**
 * Logotipo completo Thux (simbolo + wordmark) usando SVG real do brand pack.
 * variant=light → versao clara para fundos escuros (default da LP).
 * variant=dark  → versao escura para fundos claros.
 */
export function ThuxLogo({
  variant = 'light',
  className,
  loading = 'eager',
  ...rest
}: ThuxLogoProps) {
  return (
    <img
      src={fullSrc[variant]}
      alt="Thux"
      loading={loading}
      decoding="async"
      className={cn('h-6 w-auto select-none', className)}
      {...rest}
    />
  );
}

/** Apenas o simbolo (asterisco) — usado para favicon e identidade compacta */
export function ThuxMark({
  variant = 'light',
  className,
  loading = 'eager',
  ...rest
}: ThuxLogoProps) {
  return (
    <img
      src={markSrc[variant]}
      alt="Thux"
      loading={loading}
      decoding="async"
      className={cn('h-5 w-5 select-none', className)}
      {...rest}
    />
  );
}
